module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('el-form', {
    ref: "formSelectPaperType",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Adicionar Tipo de Trabalho"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Selecione um tipo de trabalho",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "change": _vm.selectPaperType
    },
    model: {
      value: (_vm.paperTypeSelect),
      callback: function($$v) {
        _vm.paperTypeSelect = $$v
      },
      expression: "paperTypeSelect"
    }
  }, _vm._l((_vm.dependencies.paper_types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "disabled": _vm.checkPaperTypeSelected(item.id),
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "custom-table-list paper-types-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.eventPaperTypes), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.paper_type.name))]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Início:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(item.submission_start_datetime)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Término:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(item.submission_end_datetime)))])]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Informar área do CNPq:")]), _vm._v(" " + _vm._s(item.knowledge_area ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Dias para edição:")]), _vm._v(" " + _vm._s(item.edit_limit_days))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Limite de autores:")]), _vm._v(" " + _vm._s(item.author_limit))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Limite de palavras-chave:")]), _vm._v(" " + _vm._s(item.keywords_limit))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Possui triagem:")]), _vm._v(" " + _vm._s(item.screening ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Co-autores precisam estar inscritos:")]), _vm._v(" " + _vm._s(item.author_subscribed ? 'Sim' : 'Não') + "\n                ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Precisa orientador:")]), _vm._v(" " + _vm._s(item.advisor ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nº máximo de orientador(es):")]), _vm._v(" " + _vm._s(item.max_limit_advisor))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Precisa co-orientador:")]), _vm._v(" " + _vm._s(item.co_advisor ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nº máximo de co-orientador(es):")]), _vm._v(" " + _vm._s(item.max_limit_co_advisor))])]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('el-button', {
      staticClass: "edit-paper-type",
      attrs: {
        "type": "info",
        "title": "Editar Tipo de Trabalho"
      },
      on: {
        "click": function($event) {
          _vm.editPaperType(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "title": "Remover Tipo de Trabalho"
      },
      on: {
        "click": function($event) {
          _vm.removePaperType(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])], 1)])
  }))]), _vm._v(" "), (_vm.modalPaperTypeVisible) ? _c('el-dialog', {
    attrs: {
      "title": 'Dados do tipo de trabalho: ' + _vm.paperType.paper_type.name,
      "top": "5vh",
      "visible": _vm.modalPaperTypeVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.modalPaperTypeVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formPaperType",
    staticClass: "form-paper-type",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.paperType.submission_start_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Início Submissões"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Início Submissões"
    },
    on: {
      "input": function($event) {
        _vm.$v.paperType.submission_start_datetime.$touch()
      }
    },
    model: {
      value: (_vm.paperType.submission_start_datetime),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "submission_start_datetime", $$v)
      },
      expression: "paperType.submission_start_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.paperType.submission_start_datetime.required && _vm.$v.paperType.submission_start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.paperType.submission_end_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Término Submissões"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Término Submissões"
    },
    on: {
      "input": function($event) {
        _vm.$v.paperType.submission_end_datetime.$touch()
      }
    },
    model: {
      value: (_vm.paperType.submission_end_datetime),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "submission_end_datetime", $$v)
      },
      expression: "paperType.submission_end_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.paperType.submission_end_datetime.required && _vm.$v.paperType.submission_end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Informar área do CNPq?"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.paperType.knowledge_area),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "knowledge_area", $$v)
      },
      expression: "paperType.knowledge_area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Possui triagem"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.paperType.screening),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "screening", $$v)
      },
      expression: "paperType.screening"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Co-author precisa estar inscrito"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.paperType.author_subscribed),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "author_subscribed", $$v)
      },
      expression: "paperType.author_subscribed"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Precisa orientador"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.paperType.advisor),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "advisor", $$v)
      },
      expression: "paperType.advisor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nº máximo de orientador(es)"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": !_vm.paperType.advisor,
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.max_limit_advisor),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "max_limit_advisor", $$v)
      },
      expression: "paperType.max_limit_advisor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Limite de autores"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.author_limit),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "author_limit", $$v)
      },
      expression: "paperType.author_limit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Precisa co-orientador"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.paperType.co_advisor),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "co_advisor", $$v)
      },
      expression: "paperType.co_advisor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nº máximo de co-orientador(es)"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": !_vm.paperType.co_advisor,
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.max_limit_co_advisor),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "max_limit_co_advisor", $$v)
      },
      expression: "paperType.max_limit_co_advisor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dias para edição"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.edit_limit_days),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "edit_limit_days", $$v)
      },
      expression: "paperType.edit_limit_days"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Limite de palavras-chave"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.keywords_limit),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "keywords_limit", $$v)
      },
      expression: "paperType.keywords_limit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(false) ? _c('el-form-item', {
    attrs: {
      "label": "Limite de submissões por autor"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.paperType.max_submission_author),
      callback: function($$v) {
        _vm.$set(_vm.paperType, "max_submission_author", $$v)
      },
      expression: "paperType.max_submission_author"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Campos Obrigatórios da Submissão")]), _vm._v(" "), _c('div', {
    staticClass: "fields-check"
  }, _vm._l((_vm.paperType.fields), function(field) {
    return _c('div', {
      staticClass: "item",
      class: {
        '-checked': field.checked
      },
      on: {
        "click": function($event) {
          field.checked = !field.checked
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(field.description))]), _vm._v(" "), (field.type === 'text' || field.type === 'textarea') ? _c('div', {
      staticClass: "size"
    }, [_vm._v("\n                        Min: " + _vm._s(field.min_size) + " / Max: " + _vm._s(field.max_size) + " (caracteres)\n                    ")]) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "size"
    }, [_vm._v("\n                        Min: " + _vm._s(_vm.bytesToSize(field.min_size)) + " / Max: " + _vm._s(_vm.bytesToSize(field.max_size * 1024)) + "\n                    ")]) : _vm._e()])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.paperType.$invalid
    },
    on: {
      "click": _vm.onSavePaperType
    }
  }, [_vm._v("\n                Salvar Alterações\n            ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onHandleModalPaperType
    }
  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-flex"
  }, [_c('h2', [_vm._v("Tipos de Trabalhos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Submissões")]), _vm._v(" "), _c('th', [_vm._v("Configurações")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0470ce52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/form/PaperTypes.vue
// module id = 712
// module chunks = 2